window.shown = false; 
window.enableMockPopup = false;
 
  $(window).scroll(function(){
   if (!window.enableMockPopup) { return; }
   if ($(this).scrollTop() >= 50) {
     if (!window.shown) {
       $("#mockpopup-widget").modal('shown');
       window.shown = true;
     }
   }
 });

 var redirect = function(url, method, email) {
  var form = document.createElement('form');
  form.method = method;
  form.action = url;
  form.data = { form_type: "customer", utf8: "✓", 'contact[tags]':"newsletter", email: email };
  document.body.appendChild(form);
  form.submit();
};
 


